<mat-form-field appearance="fill" style="width: 100%">
  <mat-label>{{ dateTime.label }}</mat-label>

  <input
    matInput
    [formControl]="control"
    [placeholder]="dateTime.label"
    [mtxDatetimepicker]="dateTimePicker"
    (click)="dateTimePicker.open()"
    [required]="dateTime.isRequired"
    [min]="dateTime.isFutureDateSelected ? today : null"
    [max]="dateTime.isPastDateSelected ? today : null"
    readonly
  />

  <button
    mat-icon-button
    matSuffix
    (click)="dateTimePicker.open()"
    type="button"
  >
    <mat-icon> event </mat-icon>
  </button>

  <!-- Single unified picker -->
  <mtx-datetimepicker
    #dateTimePicker
    [type]="dateTime.valueSource"
    startView="clock"
    color="primary"
    mode="portrait"
    [twelvehour]="true"
    [touchUi]="false"
  ></mtx-datetimepicker>

  <!-- Errors -->
  @if (control.hasError('required')) {
  <mat-error>
    {{ dateTime.label }}&nbsp;{{
      'workflow.request-document.basic-details.required-error' | translate
    }}
  </mat-error>
  } @if (control.hasError('pastDateNotAllowed')) {
  <mat-error>
    {{ 'common.error.past-date-not-allowed' | translate }}
  </mat-error>
  } @if (control.hasError('futureDateNotAllowed')) {
  <mat-error>
    {{ 'common.error.future-date-not-allowed' | translate }}
  </mat-error>
  } @if (control.hasError('pastTimeNotAllowed')) {
  <mat-error>
    {{ 'common.error.past-time-not-allowed' | translate }}
  </mat-error>
  } @if (control.hasError('futureTimeNotAllowed')) {
  <mat-error>
    {{ 'common.error.future-time-not-allowed' | translate }}
  </mat-error>
  }
</mat-form-field>
